import {
  SHARE_TO_COPY_LINK,
  SHARE_TO_SAVE_TO_ALBUM,
  SHARE_TO_WECHAT_FRIEND,
} from '@/constant/share';

export const X86_INVITE_STEP = ['分享活动', '邀请新人注册', '新人绑定x86', '您享三年提成'];

export const X86_INVITE_SHARE_ACTION = [
  { action: SHARE_TO_WECHAT_FRIEND, label: '微信分享' },
  { action: SHARE_TO_COPY_LINK, label: '复制链接' },
  { action: SHARE_TO_SAVE_TO_ALBUM, label: '生成海报' },
];

export const X86_INVITE_ID = 31001;

export const PAGE_SIZE = 20;

export const ONLINE = 3;
export const UNBIND = 1;
export const UNONLINE = 2;
export const FINISHED = 4;
export const INVITER_TAB = [
  {
    label: '已在线',
    id: ONLINE,
  },
  {
    label: '未绑定',
    id: UNBIND,
  },
  {
    label: '未在线',
    id: UNONLINE,
  },
];

export const INVITER_STATUS = {
  1: {
    class: 'unbind',
    text: '未绑定',
  },
  2: {
    class: 'unonline',
    text: '设备未在线',
  },
  3: {
    class: 'online',
    text: '享受提成',
  },
  4: {
    class: 'finished',
    text: '提成结束',
  },
};

export const DEVICE_STATUS = {
  1: {
    class: 'online',
    text: '在线',
  },
  2: {
    class: 'unonline',
    text: '离线',
  },
};

// export const INVITER_STATUS = {
//   1: '未绑定',
//   2: '设备未在线',
//   3: '享受提成',
//   4: '提成结束',
// };

export const INVITER_POINT_STATUS = {
  1: 'select_notbind',
  2: 'select_offline',
  3: 'select_online',
  4: '',
};

export const MODULE = 'x86act_proxy';

export const SHARE_UNBIND_TEXT = '你还没有网心云x86设备在线，有没有遇到什么问题？';

export const SHARE_ONLINE_TEXT = '你最近上机网心云x86收益怎么样？有不清楚的可以问我。';
